import { Container } from './styles'

import reactIcon from '../../assets/react-icon.svg'
import linkedinIcon from '../../assets/linkedin.png'
import githubIcon from '../../assets/github.png'
import instagramIcon from '../../assets/instagram.png'
import discordIcon from '../../assets/discord.png'
import behance from '../../assets/behance.svg'
import twitter from '../../assets/twitter-icon.svg'
import medium from '../../assets/medium-icon.svg'

export function Footer() {
  return (
    <Container className="footer">
      <a href="/" className="logo">
        <span>Ritik</span>
        <span>Chopra</span>
      </a>
      <div>
        <p>
        This site was made with a <img src={reactIcon} alt="React" /> and lot of
          <span>❤️</span>
        </p>
      </div>

      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/ritik-chopra28"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedinIcon} alt="Linkedin" />
        </a>

        <a
          href="https://www.instagram.com/rkstarji/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagramIcon} alt="Instagram" />
        </a>

        <a
          href="https://twitter.com/rkstarji/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={twitter} alt="Instagram" />
        </a>

        <a
          href="https://medium.com/@ritik-chopra28"
          target="_blank"
          rel="noreferrer"
        >
          <img src={medium} alt="Instagram" />
        </a>

        <a
          href="https://github.com/ritikjainkkar"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>


        <a
          href="https://www.behance.net/sethiavibha"
          target="_blank"
          rel="noreferrer"
        >
          <img src={behance} alt="behance" />
        </a>
      </div>
    </Container>
  )
}
//secret key 6LfT700eAAAAAEIB_2Lc7xb2Xb3Aa2zALPbzyb4h
//site key 6LfT700eAAAAALjLGMqGpgOT-Ln31M4mTpsVfKF3